import { render } from "./PatientTask.vue?vue&type=template&id=2213cbb6&scoped=true"
import script from "./PatientTask.js?vue&type=script&lang=js"
export * from "./PatientTask.js?vue&type=script&lang=js"

import "../../../public/assets/CSS/saveiconfile.css?vue&type=style&index=0&lang=css"
import "./PatientTask.vue?vue&type=style&index=1&id=2213cbb6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2213cbb6"]])

export default __exports__